import styled from 'styled-components'

import { darkgray, inputgray, bordergray, whitegray } from '../../styles/colors'

export const Wrap = styled.div`
  margin-bottom: 1rem;
`

export const Label = styled.label`
  display: block;
  margin-bottom: .5rem;
  color: ${darkgray};
`

export const StyledSelect = styled.select`
  appearance: none;
  width: 100%;
  box-sizing: border-box;
  padding: 0.75rem 1rem;

  font-size: 16px;
  font-weight: 300;
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  background-color: ${whitegray};
  background-image: url(${props => props.chevron});
  background-position: calc(100% - 14px) center;
  background-repeat: no-repeat;
  background-size: 20px 20px;

  &:focus {
    border: 1px solid ${inputgray};
    box-shadow: 0px 0px 5px 0px ${inputgray};
    outline: none;
  }

  &::-ms-expand {
    display: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/Select/styles.js